import { useAuthDataContext } from '../context/auth/auth.provider';
import { analytics } from 'firebase';
import { appConfig } from '../config/app';

const useLogEventInAnalytics = () => {
  const { user } = useAuthDataContext();

  const logEvent = async (
    eventName: string,
    eventExtraData?: { [key: string]: any }
  ) => {
    if(user) {
      await analytics().logEvent(eventName, {
        app: appConfig?.NAME,
        id: user?.id,
        ...eventExtraData,
      });
    } else {
      await analytics().logEvent(eventName, {
        app: appConfig?.NAME,
        ...eventExtraData,
      });
    }
  };

  return {
    logEvent,
  };
};

export default useLogEventInAnalytics;
